import type { BeforeSendEvent } from '@vercel/analytics/react'

// Pages whose query string can carry what a visitor typed (the Judge's `?q=`
// prefill, the collection's `?filter=` and a binder's `?q=`; plan
// nav-search-2026-10-16, Pass 2). Page analytics (GA4 and Vercel Web
// Analytics) record the bare path for these, never the text. Both readers
// share this one list.
export const QUERY_FREE_PATHS: ReadonlySet<string> = new Set(['/rules', '/collection'])
/** Prefixes whose every sub-path is query-free too (/collection/binders/12?q=). */
export const QUERY_FREE_PREFIXES: readonly string[] = ['/collection/']

/** Whether page analytics drop the query on this path. */
export function isQueryFreePath(pathname: string): boolean {
  return QUERY_FREE_PATHS.has(pathname) || QUERY_FREE_PREFIXES.some(p => pathname.startsWith(p))
}

/** pathname + search, with the search dropped on a query-free path. */
export function analyticsPagePath(pathname: string, search: string): string {
  return isQueryFreePath(pathname) ? pathname : pathname + search
}

/**
 * Vercel Web Analytics `beforeSend`: rewrites an event URL on a query-free
 * page to its origin + path (query and hash dropped). Every other URL, and
 * anything that does not parse, passes through unchanged.
 */
export function vercelAnalyticsBeforeSend(event: BeforeSendEvent): BeforeSendEvent {
  let url: URL
  try {
    url = new URL(event.url)
  } catch {
    return event
  }
  if (!isQueryFreePath(url.pathname)) return event
  return { ...event, url: url.origin + url.pathname }
}
